import { configureStore } from '@reduxjs/toolkit';
import dateFilterReducer from './dateFilter';
import createUserReducer from './createUser';
import balanceValuesReducer from './balanceValues';
import dreValuesReducer from './dreValues';
import bankValueReducer from './bankValue';
import dashboardValuesReducer from './dashboardValues';
import calendarValuesReducer from './calendarValues';
import entryValuesReducer from './entryValues';
import loginValuesReducer from './loginValues';
import newCustomerReducer from './newCustomer';

const store = configureStore({
  reducer: {
    dateFilter: dateFilterReducer,
    createUser: createUserReducer,
    balanceValues: balanceValuesReducer,
    dreValues: dreValuesReducer,
    bankValue: bankValueReducer,
    dashboardValues: dashboardValuesReducer,
    calendarValues: calendarValuesReducer,
    entryValues: entryValuesReducer,
    loginValues: loginValuesReducer,
    newCustomer: newCustomerReducer,
  },
});

export default store;
